/* eslint-disable no-nested-ternary */
import React, { useContext, useCallback, useState, useMemo } from 'react';
import classNames from 'classnames';
import Container from 'ls-common-client/dist/components/Container';
import SearchBar from '../SearchBar';
import Logo from './Logo';
import Wrapper from './Wrapper';
import SlideMenu from './SlideMenu';
import LoginMenu from './LoginMenu';
import { Context } from '../../context/AppContext';
import useScrollPosition from '../../hooks/useScrollPosition';
import { MODALS } from '../../constants';
import OriginShine from '../../assets/misc/originstate-shine.svg';
import OriginBall from '../../assets/misc/originstate-ball.svg';
import useOnAddABusinessClick from '../../hooks/useOnAddABusinessClick';
import './styles.css';

const Header = ({
  showLocationInput,
  slideIn,
  showSearch,
  showIconSearch,
  hideReview,
  stateOfOrigin,
  hideSearch,
  headerBottom,
  headerTransparent,
  onHeaderShow,
  onBannerShow,
  is404,
  profile,
}) => {
  const {
    media: { desktop, tablet, mobile },
    modal: { showModal },
  } = useContext(Context);
  const [showHeader, setShowHeader] = useState(false);
  const { onAddABusinessClick } = useOnAddABusinessClick();

  const links = [
    {
      text: 'Write a Review',
      onClick: () =>
        showModal(MODALS.REVIEW_FORM, {
          disableDefaults: true,
        }),
      icon: <i className="icon-generalstarempty" />,
      show: desktop && !hideReview,
      className: 'Header__writeAReview',
      dataCtaclick: 'Write Review',
      dataCtatext: 'Write a Review',
    },
    {
      text: 'Add a Business',
      onClick: () => onAddABusinessClick(),
      icon: <i className="icon-generalwhatsonbrowse" />,
      show: desktop,
      className: 'Header__addABusiness',
      dataCtaclick: 'add_business',
      dataCtatext: 'Add a Business',
    },
  ];

  const callback = useCallback(() => {
    setShowHeader(slideIn && window.scrollY > 44);
  }, [slideIn]);

  useScrollPosition(null, callback);

  const backgroundOverlay = useMemo(() => {
    if (stateOfOrigin && (stateOfOrigin === 'QLD' || stateOfOrigin === 'NSW')) {
      return OriginShine;
    }
    return null;
  }, [stateOfOrigin]);

  const stateOfOriginTitle = useMemo(() => {
    if (stateOfOrigin) {
      if (stateOfOrigin === 'NSW') {
        return (
          <div className="StateOfOrigin--title">
            <img src={OriginBall} alt="origin" />
            <p>
              GO <span>BLUES</span>
            </p>
          </div>
        );
      }
      if (stateOfOrigin === 'QLD') {
        return (
          <div className="StateOfOrigin--title">
            <img src={OriginBall} alt="origin" />
            <p>
              GO <span>MAROONS</span>
            </p>
          </div>
        );
      }
    }
    return null;
  }, [stateOfOrigin]);

  return (
    <Wrapper
      slideIn={slideIn}
      headerBottom={headerBottom}
      onHeaderShow={onHeaderShow}
      onBannerShow={onBannerShow}
      className={classNames({
        [`Header__StateOfOrigin Header__StateOfOrigin--${stateOfOrigin}`]: stateOfOrigin,
        'Header__wrapper--backgroundOverlay': backgroundOverlay,
        'Header--headerTransparent': headerTransparent,
      })}
      style={
        backgroundOverlay
          ? {
              backgroundImage: `url(${backgroundOverlay})`,
            }
          : {}
      }
    >
      <div className="Header__left">
        <SlideMenu hideReview={hideReview} />
        <Logo small={mobile && showHeader && !hideSearch} mobile={mobile} />
        {!mobile &&
          !hideSearch &&
          (showLocationInput || showSearch || showHeader) && (
            <Container
              marginLeft="16px"
              marginRight="16px"
              width="100%"
              maxWidth={desktop || tablet ? '500px' : '200px'}
            >
              <SearchBar id="navbarDesktopSearch" type="navbar" />
            </Container>
          )}
      </div>
      {stateOfOriginTitle && (desktop || tablet) && (
        <div className="Header__center">{stateOfOriginTitle}</div>
      )}
      <div className="Header__right">
        {desktop &&
          links.map(item => {
            if (!item.show) return null;
            if (item.button)
              return (
                <div
                  key={item.button}
                  className={classNames('Header__link', {
                    [item.className]: item.className,
                  })}
                >
                  {item.button}
                </div>
              );
            return (
              <div
                key={item.text}
                className={classNames('Header__link', {
                  [item.className]: item.className,
                })}
              >
                <button
                  data-ctaclick={item.dataCtaclick}
                  data-ctatext={item.dataCtatext}
                  className="Header__link__button"
                  onClick={item.onClick}
                  type="button"
                >
                  {item.icon}
                  {item.text}
                </button>
              </div>
            );
          })}
      </div>
      {mobile &&
        !hideSearch &&
        (showLocationInput || showSearch || showIconSearch || showHeader) && (
          <Container
            className="Header__searchIconContainer"
            width="44px"
            marginRight="8px"
            marginTop="2px"
          >
            <SearchBar id="navbarMobileSearch" type="icon" />
          </Container>
        )}
      <LoginMenu profile={profile} is404={is404} />
    </Wrapper>
  );
};

export default Header;
